import React from 'react';
import { Card as ReactstrapCard, CardProps } from 'reactstrap';

interface CustomCardProps extends CardProps {
  isCompact?: boolean;
}

/**
 * CustomCard component that wraps reactstrap Card component
 * and filters out the isCompact prop to prevent React warnings.
 */
const CustomCard: React.FC<CustomCardProps> = ({ isCompact, className, ...props }) => {
  // Add a custom class for compact styling if isCompact is true
  const cardClassName = isCompact 
    ? `${className || ''} card-compact`.trim()
    : className;
  
  // Pass all props except isCompact to the reactstrap Card
  return <ReactstrapCard className={cardClassName} {...props} />;
};

export default CustomCard; 